import { useTranslationsReady, useWebTranslation } from "../../../translations";
import React, { ReactElement } from "react";
import ArticleCard from "../../../components-shared/ArticleCard";
import styles from "./ArticleList.module.css";
import {
  ArticleCardArticle,
  ComponentArticleList_componentArticleList,
} from "../../../../__generated__/graphql";
import { gql } from "@apollo/client";
import { ContentfulComponentType } from "../types";
import { DocumentNode } from "graphql";
import { ContentfulC2A } from "../ContentfulC2A";
import TextFieldsV2 from "../TextFieldsV2";
import Gutter from "ui-kit/Gutter";
import { FlexCol } from "ui-kit/Layout/Flex";

const ArticleCards = ({
  articles,
  emptyText,
}: {
  articles: readonly (ArticleCardArticle | null)[];
  emptyText: string;
}): ReactElement =>
  articles.length ? (
    <>
      {articles.map((item) => (
        <div key={item?.sys.id}>
          <ArticleCard variant="white" article={item as ArticleCardArticle} />
        </div>
      ))}
    </>
  ) : (
    <div className={styles.noArticles}>{emptyText}</div>
  );

export const ContentfulArticleList: ContentfulComponentType<ComponentArticleList_componentArticleList> & {
  fragmentFull: DocumentNode;
} = ({ description, title, articlesCollection, c2A }) => {
  useTranslationsReady();

  const { t } = useWebTranslation();
  const articles = (articlesCollection?.items ??
    []) as (ArticleCardArticle | null)[];

  return (
    <div className="container">
      <TextFieldsV2 title={title} text={description} center />
      <div className={styles.content}>
        <div>
          <ArticleCards articles={articles} emptyText={t("articles.empty")} />
        </div>
      </div>
      {c2A && (
        <FlexCol alignItems="center" justifyContent="center">
          <Gutter size={3} />
          <ContentfulC2A {...c2A} />
        </FlexCol>
      )}
    </div>
  );
};

ContentfulArticleList.fragment = gql`
  fragment ArticleList on ComponentArticleList {
    sys {
      publishedAt
      id
    }
  }
`;

ContentfulArticleList.fragmentFull = gql`
  query ComponentArticleList($id: String!, $locale: String, $preview: Boolean) {
    componentArticleList(id: $id, locale: $locale, preview: $preview) {
      title
      description
      #    FIXME QUERY COMPLEXITY. this overloads query heavily. Probably use another query for this
      articlesCollection(limit: 90) {
        items {
          ...ArticleCardArticle
          sys {
            id
          }
          org
        }
      }
      c2A {
        ...C2A
      }
      sys {
        publishedAt
      }
    }
  }
  ${ArticleCard.fragments.article}
  ${ContentfulC2A.fragment}
`;
